export const navLinks = [
  { label: "L'histoire", to: "/histoire" },
  { label: "Programme", to: "/programme" },
  { label: "Participer", to: "/participer" },
  { label: "Partenaires", to: "/partenaires" },
  { label: "Contact", to: "/contact" },
];

export const logoUrl = "https://cdn.magicpatterns.com/uploads/bDD8LuG3MMfGEqw75q6WBY/image002-5.png";

export const images = {
  village: "https://cdn.magicpatterns.com/patterns/generated-images/79cfd9eb-f7f6-4454-b95f-5513530fded2.jpg",
  volunteers: "https://cdn.magicpatterns.com/patterns/generated-images/6b164ae2-102b-4942-8a3f-d2839a5906f5.jpg",
  hero: "https://cdn.magicpatterns.com/patterns/generated-images/f0a8473a-bcc7-4f6f-81a6-aa8ec12f225f.jpg",
  archive1978: "https://cdn.magicpatterns.com/patterns/generated-images/3af57a85-8235-4cf3-ac93-dca28c755f17.jpg",
  pertuiset: "https://cdn.magicpatterns.com/patterns/generated-images/1d447f59-1d15-4a56-9d65-0c50f9a3bce8.jpg",
  festival: "https://cdn.magicpatterns.com/patterns/generated-images/e6742bb3-9dbd-41a8-829c-753a2d149f65.jpg",
  landing: "https://cdn.magicpatterns.com/patterns/generated-images/617ebd1a-4aa4-4c43-a069-2d468cf3fb00.jpg",
};

export const eventDate = "2028-06-23T10:00:00+02:00";

export const timeline = [
  {
    year: "1978",
    title: "Le premier « parachute de pente »",
    text: "Le 25 juin, Jean-Claude Bétemps et André Bohn s'élancent du Pertuiset avec une voile de parachute. Un nouveau sport vient de naître.",
  },
  {
    year: "1980s",
    title: "Les premières écoles",
    text: "La pratique se structure, les voiles évoluent et les premières écoles ouvrent autour de Mieussy et dans les Alpes.",
  },
  {
    year: "2000s",
    title: "Un sport mondial",
    text: "Le parapente se pratique sur tous les continents. Des centaines de milliers de pilotes volent grâce à l'idée née ici.",
  },
  {
    year: "2028",
    title: "50 ans, retour au berceau",
    text: "Pilotes, pionniers et habitants se retrouvent à Mieussy pour célébrer un demi-siècle de vol libre.",
  },
];

export const programme = [
  {
    day: "Vendredi",
    date: "23 juin",
    title: "Ouverture & mémoire",
    items: ["Exposition « 1978, l'envol » à la salle des fêtes", "Projection de films d'archives", "Soirée d'accueil des pilotes"],
  },
  {
    day: "Samedi",
    date: "24 juin",
    title: "Le grand rassemblement",
    items: ["Décollages en masse depuis le Pertuiset", "Voltige et démonstrations", "Village du vol libre & concert"],
  },
  {
    day: "Dimanche",
    date: "25 juin",
    title: "Le jour anniversaire",
    items: ["Vol commémoratif à l'heure exacte du premier vol", "Hommage aux pionniers", "Repas partagé au village"],
  },
];

export const involvement = [
  {
    title: "Devenir bénévole",
    text: "Accueil, navettes, sécurité au décollage : rejoignez l'équipe de bénévoles qui feront vivre le week-end.",
    cta: "Je m'inscris",
    to: "/participer",
  },
  {
    title: "Adhérer à l'association",
    text: "Soutenez la préparation du cinquantenaire et participez aux décisions.",
    cta: "Adhérer",
    to: "/participer",
  },
  {
    title: "Devenir partenaire",
    text: "Associez votre entreprise à un moment historique pour la Haute-Savoie.",
    cta: "Nous contacter",
    to: "/partenaires",
  },
];
